import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { CardLayoutModule } from 'src/app/common-components/card-layout/card-layout.module';
import { TwoColumnLayoutModule } from 'src/app/common-components/column-layouts/two-column-layout/two-column-layout.module';
import { FormFooterModule } from 'src/app/common-components/form-footer/form-footer.module';
import { UpdateDetailsModule } from 'src/app/common-components/update-details/update-details.module';
import { AddPromptModule } from '../add-prompt/add-prompt.module';
import { ErrorPageModule } from '../error-page/error-page.module';
import { UserPreferenceDetailComponent } from './containers/user-preference-detail.component';
import { UserPreferenceDetailEffects } from './state/user-preference-detail.effects';
import { reducer, userPreferenceDetailFeatureKey } from './state/user-preference-detail.reducer';
import { UserPreferenceDetailViewComponent } from './views/user-preference-detail-view.component';

@NgModule({
   declarations: [UserPreferenceDetailViewComponent, UserPreferenceDetailComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatInputModule,
      MatCardModule,
      MatMenuModule,
      AddPromptModule,
      MatIconModule,
      MatButtonModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      TwoColumnLayoutModule,
      FormFooterModule,
      AppRoutingModule,
      UpdateDetailsModule,
      ErrorPageModule,
      CardLayoutModule,
      MatRadioModule,
      StoreModule.forFeature(userPreferenceDetailFeatureKey, reducer),
      EffectsModule.forFeature([UserPreferenceDetailEffects]),
   ],
})
export class UserPreferenceDetailModule {}
